import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/medication-request-form";

export const pagingMediRequestForm = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getMediRequestFormById = (mediRequestFormId) => axios.get(API_PATH + "/get-by-id/" + mediRequestFormId);

export const saveMediRequestForm = mediRequestForm => axios.post(API_PATH + '/save-or-update', mediRequestForm);

export const deleteMediRequestForm = mediRequestFormId => axios.delete(API_PATH + '/mark-delete/' + mediRequestFormId);

export const getAllMedicationRequestForm = () => axios.get(API_PATH + "/get-all");

//tách đơn
export const separateMediReqByStore = (mediRequestForm) => axios.post(API_PATH + "/separate-medi-req-by-store", mediRequestForm);
